import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from "@angular/core";
import { Tour, TourConfig } from "./data";
import { TourService } from "./tour.service";

@Component({
  selector: 'tour-selection',
  template: `
  <div *ngIf="tours?.length">
    <ul *ngIf="list">
      <li *ngFor="let tc of tours">
        <a href="#" [ngbTooltip]="tc.description" (click)="startTour(tc)">{{tc.title}}</a>
      </li>
    </ul>
    <form *ngIf="!list" class="row row-cols-lg-auto row-cols-md-auto g-3 align-items-center">
      <div class="col-12">
        <label for="selTour" class="form-label">Select a tour</label>
      </div>
      <div class="col-12">
        <select id="selTour" class="form-select" [(ngModel)]="tour" (ngModelChange)="tourSelectionChanged()" [ngModelOptions]="{standalone: true}">
          <option *ngFor="let tc of tours" [ngValue]="tc">{{tc.title}}</option>
        </select>
      </div>
      <div class="col-12">
        <button class="btn btn-primary mb-2"
                [ngClass]="{'disabled':!tour}"
                [disabled]="!tour"
                ngbTooltip="Start the tour"
                (click)="startTour()"><i class="fa fa-play"></i></button>
      </div>
      <div class="col-12">
        <p>{{tour?.description}}</p>
      </div>
    </form>
  </div>
`
})
export class TourSelectionComponent implements OnInit, OnChanges {
  @Input() list = false;
  @Input() tours:TourConfig[];
  @Input() tour:TourConfig;
  @Output() tourChanged = new EventEmitter<Tour>();
  @Output() tourStarted = new EventEmitter<Tour>();

  constructor(private tourService:TourService){

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.tours?.currentValue?.length && !this.tour){
      this.tour = this.tours[0];
      this.tourSelectionChanged();
    }
  }

  ngOnInit(): void {

  }

  tourSelectionChanged(): void {
    this.tourService.getTour(this.tour).subscribe(tour=>{
      this.tourChanged.emit(tour);
    });
  }

  startTour(tour?:TourConfig): void {
    this.tourService.getTour(tour||this.tour).subscribe(tour=>{
      this.tourStarted.emit(tour);
    });
  }
}

